import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./css/App.css";
import Navbar from "./components/NavBarRedesigned";
import IntroPage from "./components/NewDesignComponents/introComponent/IntroPage";
import SmartReportPage from "./components/SmartReportsRedesigned";
import VizAppPage from "./components/VizappRedesigned";
import AnalyticsPage from "./components/AnalyticsRedesigned";
import PersonalProductsPage from "./components/PersonalProductsRedesigned";
import ScrollToTop from "./components/ScrollToTop";
import UserJourneyPage from "./components/NewDesignComponents/userJourneyComponent/UserJourneyPage";
import SmartReportingPage from "./components/NewDesignComponents/smartReporting/SmartReportingPage";
import SmartReportingNewPage from "./components/NewDesignComponents/smartReportingNew/SmartReportingNewPage";
import VizapPage from "./components/NewDesignComponents/vizap/VizapPage";
import UserEngagementPage from "./components/NewDesignComponents/userJourney/UserEngagementPage";
import TestimonialsPage from "./components/NewDesignComponents/testimonials/TestimonialsPage";
import RoiCalculatorPage from "./components/NewDesignComponents/roiCalculator/RoiCalculatorPage";
import Footer from "./components/Footer";

function App() {
  const location = useLocation();
  const isIntroPage = location.pathname === "/";

  // ── Footer Clarity Event Tracking (Global — runs once) ──────────────────
  useEffect(() => {
    const socialPlatforms = {
      'facebook.com': 'facebook',
      'instagram.com': 'instagram',
      'linkedin.com': 'linkedin',
      'twitter.com': 'twitter',
      'x.com': 'twitter',
      'youtube.com': 'youtube',
    };

    const handleClick = (e) => {
      if (typeof window.clarity !== 'function') return;

      // Book Demo button (footer)
      const btn = e.target.closest('button');
      if (btn) {
        const text = btn.innerText?.trim().toLowerCase() || '';
        if (text.includes('book demo')) {
          window.clarity('set', 'cta_clicked', 'book_demo_footer');
          window.clarity('event', 'footer_book_demo_clicked');
        }
      }

      // Social Icons (anchor tags — tracked by href domain)
      const link = e.target.closest('a[href]');
      if (link) {
        const href = link.href?.toLowerCase() || '';
        Object.entries(socialPlatforms).forEach(([domain, platform]) => {
          if (href.includes(domain)) {
            window.clarity('set', 'footer_social_clicked', platform);
            window.clarity('event', `footer_social_${platform}_clicked`);
          }
        });
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  // ────────────────────────────────────────────────────────────────────────

  return (
    <div
      className="font"
      style={{
        width: "100vw",
        minHeight: "100vh",
        backgroundColor: "#ffffff",
        overflowX: "hidden",
      }}
    >
      <ScrollToTop />
      {/* Navbar is integrated inside HeroSection for intro page */}
      {!isIntroPage && <Navbar />}
      <Routes>
        <Route path="/" element={<IntroPage />} />
        <Route path="/user-journey" element={<UserJourneyPage />} />
        <Route path="/smartReporting" element={<SmartReportingPage />} />
        <Route path="/smartReport" element={<SmartReportingNewPage />} />
        <Route path="/vizApp" element={<VizapPage />} />
        <Route path="/smartReports" element={<SmartReportPage />} />
        <Route path="/vizappPage" element={<VizAppPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/healthTools" element={<PersonalProductsPage />} />
        <Route path="/engagement" element={<UserEngagementPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/roi-calculator" element={<RoiCalculatorPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
